import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddDuplicateCarnival from './addDuplicateCarnival';
import {
    createDuplicateCarnival,
    getCarnivalDataForUpdation,
    // getLeadInfraId
} from 'services/redux/brandActivtion/conductCamp/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    carnivalData: state.ConductCampReducer.carnivalData,
    leadInfraId: state.ConductCampReducer.leadInfraId,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        documentUploadUrlPublic,
        getCarnivalDataForUpdation,
        createDuplicateCarnival,
        // getLeadInfraId
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddDuplicateCarnival);
